export const environment = {
    production: false,
    apiBaseUrl: 'https://beast-api-dev-dot-beast-212905.el.r.appspot.com',
    apiPrefix: 'api/v1',
};
